namespace GeniuzPOS.Member {
    export class MbReport01_DtColumns {
        static columnsKey = 'Member.MbReport01_Dt';
    }
}
